/** The references object of all modules needed for components initialization */
var references = {
	/** Components from extension cartridge */
	'global.custom': require('./global.custom')
};

/** The components initialization configuration object */
var configuration = {
	'global': {
		'components': {
			'global.custom': {},
		}
	},
	'product': {
		'components': {
			'carousel': {},
		}
	}
};

module.exports = {
	'configuration': configuration,
	'references': references
};
